<!--this is going to be the original look-->
@if (homepageOption() == 0) {
  <ion-header [translucent]="true" [ngClass]="{'HeaderRounded': setting.configuration?.welcomeOptions?.addWelcomeMessage && this.auth.isAuthenticated}">
    <ion-toolbar class="lacademie-toolbar">
      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>
      <ion-title >
        <div class="titleBar">
          {{ title  | translate }}
          @if (NotificationService.showNotificationBell) {
            <ion-buttons class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
              <div class="bellimgContainer">
                <!--<fa-icon icon="bell" id="bellsize"></fa-icon>-->
                <fa-icon [icon]="bellIcon" id="bellsize_base"></fa-icon>
                <!--<img id="bellsize" src="../../../../assets/icon/notification/bell.png" alt="">-->
                @if (this.valideNotification > 0) {
                  <div class="notificationCircle">
                    <p>{{this.valideNotification}}</p>
                  </div>
                }
              </div>
            </ion-buttons>
          }
        </div>
      </ion-title>
    </ion-toolbar>

    <!--add this for the welcome message (ideally in its own component)-->
    @if(setting.configuration?.welcomeOptions?.addWelcomeMessage && this.auth.isAuthenticated) {
      <div class="WelcomeContainer">
        <div class="WelcomeMessage">
          {{ 'Welcome.Hi' | translate}} {{ this.auth?.firstName }}
        </div>

        @if(this.primary){
          <div class="WelcomePointsContainer" [style.--points-container-color]="setting.configuration?.welcomeOptions?.giftCardInfoContainerColor">
            <div class="GiftCardPoints">
              {{ this.primary?.PointsBalance + 'pts' }}
            </div>
            <div class="GiftCardAmmount">
              {{ this.primary?.GiftBalance | currency }}
            </div>
          </div>
        }
        
      </div>
    }
  </ion-header>
}

@if (homepageOption() == 0) {
  <ion-content [fullscreen]="false" [ngClass]="{'disable-background-color': !this.setting.UIshowBackground}">
    <div class="container">
      <!--
      <ion-slides #slider *ngIf="homeImages.Entries.length > 0" loop="true" pager="true">
        <ion-slide *ngFor="let entry of homeImages.Entries" [style.background-image]="'url(' + entryUrl(entry) + ')'" (click)="entryClicked(entry)">
        </ion-slide>
      </ion-slides>
      -->
      <!--
      <swiper
        #swiper
        *ngIf="homeImages.Entries.length > 0"
        [loop]="true"
        [pagination]="{ clickable: true }"
        [navigation]="true"
        class="mySwiper"
        >
        <ng-template swiperSlide *ngFor="let entry of homeImages.Entries">
          <div
            class="slide"
            [style.background-image]="'url(' + entryUrl(entry) + ')'"
            (click)="entryClicked(entry)"
            >
          </div>
        </ng-template>
        </swiper
        -->
        @if (homeImages.Entries.length > 0) {
          <swiper-container
            #swiper
            loop="true"
            navigation="true"
            pagination='{"clickable": true}'
            style="height: 100%"
            >
            @for (entry of homeImages.Entries; track entry) {
              <swiper-slide>
                <!--
                <div
                  class="slide"

                  [ngStyle]="{ 'background-Image': 'url(' + entryUrl(entry) + ')' }"
                  (click)="entryClicked(entry)"
                  >
                -->
                <div
                  class="marketingItemReposition"
                  style="height: 100%; width: 100%;"
                  decoding="async"
                  fetchpriority="high"
                  [style.background-image]="entryUrl(entry)"
                  (click)="entryClicked(entry)"
                  >

                  
                  <!-- Optional content -->
                  <!--
                  <a *ngIf="hasLink(entry)" [href]="entry.Href">
                    <img [src]="entry.Url" />
                  </a>
                  <img *ngIf="!hasLink(entry)" [src]="entry.Url" />
                  -->
                </div>
              </swiper-slide>
            }
          </swiper-container>
        }
      </div>
    </ion-content>
  }

  <!-- original look above -->

  <!--this is going to be the new look 1-->
  <!--
  <ion-header *ngIf="true">
    <ion-toolbar class="removeBackground">
      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>
      <ion-title >
        <div class="titleBar">

          {{ title  | translate }}

          <ion-buttons *ngIf="NotificationService.showNotificationBell" class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
            <div class="bellimgContainer">
              <fa-icon icon="bell" id="bellsize"></fa-icon>
              <div class="notificationCircle" *ngIf="this.valideNotification > 0">
                <p>{{this.valideNotification}}</p>
              </div>
            </div>
          </ion-buttons>

        </div>
      </ion-title>
    </ion-toolbar>
  </ion-header>
  -->


  <!-- first new look-->
@if (homepageOption() == 1) {
  <ion-content [fullscreen]="false" [ngClass]="{'disable-background-color': !this.setting.UIshowBackground}">
    <ion-toolbar class="disable-background-color repositioning">
      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>
      <ion-title >
        <div class="titleBar_type2">
          <!-- i need to send the location of the bell through the function "opennotificationbell"-->
          @if (NotificationService.showNotificationBell) {
            <ion-buttons #notificationV1 class="notificationbutton" (click)="NotificationBellService.openNotificationBell(this.AllNotifications, 1)" class="bellBtnPosition">
              <div class="bellimgContainer">
                <!--<fa-icon icon="bell" id="bellsize"></fa-icon>-->
                <fa-icon [icon]="bellIcon" id="bellsize"></fa-icon>
                @if (this.valideNotification > 0) {
                  <div class="notificationCircle">
                    <p>{{this.valideNotification}}</p>
                  </div>
                }
              </div>
            </ion-buttons>
          }
        </div>
      </ion-title>
    </ion-toolbar>
    <div class="container">
      <!--
      <ion-slides #slider *ngIf="setting.configuration.homePageConfiguration.homePageVersion1.length > 0" (ionSlideDidChange)="onSlideChanged()" loop="true" pager="true" style="height: 100%">
        <ion-slide *ngFor="let page of setting.configuration.homePageConfiguration.homePageVersion1" [style.background-image]="getbackgroundImage(page)" (click)="entryClicked(page)" class="marketingItemReposition" style="height: 100%">
          <div class="marketing_box">
            <div class="foregroundContainer" *ngIf="HasForgroundImg(page)">
              <div class="foregroundSetup" [style.background-image]="getforegroundImage(page)"> </div>
            </div>
            <div class="titleText" #titleTextRef [innerHTML]="htmlContent"></div>
            <div *ngIf="this.currentLanguage == 'en'">
              <button *ngIf="this.currentLanguage == 'en' && page.buttonLink && page.desktopButtonTextEN" (click)="openStore(page.buttonLink)" class="styledButton"> {{ stripHtml(page.desktopButtonTextEN) }} </button>
              <button *ngIf="!(this.currentLanguage == 'en' && page.buttonLink && page.desktopButtonTextEN)" style="visibility: hidden;" class="styledButton"> {{ stripHtml(page.desktopButtonTextEN) }} </button>
            </div>
            <div *ngIf="this.currentLanguage == 'fr'">
              <button *ngIf="this.currentLanguage == 'fr' && page.buttonLink && page.desktopButtonTextFR" (click)="openStore(page.buttonLinkFR)" class="styledButton"> {{ stripHtml(page.desktopButtonTextFR) }} </button>
              <button *ngIf="!(this.currentLanguage == 'fr' && page.buttonLink && page.desktopButtonTextFR)" style="visibility: hidden;" class="styledButton"> {{ stripHtml(page.desktopButtonTextFR) }} </button>
            </div>
          </div>
        </ion-slide>
      </ion-slides>
      -->
      <!--
      <swiper
        #swiper
        *ngIf="setting.configuration.homePageConfiguration.homePageVersion1.length > 0"
        [loop]="true"
        [pagination]="{ clickable: true }"
        [navigation]="true"
        (slideChange)="onSlideChanged()"
        style="height: 100%"
        >
        -->
        <!--
        <swiper
          #swiper
          *ngIf="setting.configuration.homePageConfiguration.homePageVersion1.length > 0"
          [loop]="true"
          [pagination]="{ clickable: true }"
          [navigation]="true"
          (swiperSlideChange)="onSlideChanged()"
          style="height: 100%"
          >
          <ng-template swiperSlide *ngFor="let page of setting.configuration.homePageConfiguration.homePageVersion1">
            <div
              class="marketingItemReposition"
              [style.background-image]="getbackgroundImage(page)"
              style="height: 100%"
              (click)="entryClicked(page)"
              >
              <div class="marketing_box">
                <div class="foregroundContainer" *ngIf="HasForgroundImg(page)">
                  <div class="foregroundSetup" [style.background-image]="getforegroundImage(page)"></div>
                </div>
                <div class="titleText" #titleTextRef [innerHTML]="htmlContent"></div>
                <div *ngIf="this.currentLanguage == 'en'">
                  <button *ngIf="page.buttonLink && page.desktopButtonTextEN"
                    (click)="openStore(page.buttonLink)"
                    class="styledButton">
                    {{ stripHtml(page.desktopButtonTextEN) }}
                  </button>
                  <button *ngIf="!(page.buttonLink && page.desktopButtonTextEN)"
                    style="visibility: hidden;"
                    class="styledButton">
                    {{ stripHtml(page.desktopButtonTextEN) }}
                  </button>
                </div>
                <div *ngIf="this.currentLanguage == 'fr'">
                  <button *ngIf="page.buttonLink && page.desktopButtonTextFR"
                    (click)="openStore(page.buttonLinkFR)"
                    class="styledButton">
                    {{ stripHtml(page.desktopButtonTextFR) }}
                  </button>
                  <button *ngIf="!(page.buttonLink && page.desktopButtonTextFR)"
                    style="visibility: hidden;"
                    class="styledButton">
                    {{ stripHtml(page.desktopButtonTextFR) }}
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </swiper>
        -->
      @if (setting.configuration.homePageConfiguration.homePageVersion1.length > 0) {
        <swiper-container
          #swiper
          loop="true"
          navigation="false"
          pagination='{"clickable": true}'
          style="height: 100%"
          (slidechange)="onSlideChanged()"
          >
          @for (page of setting.configuration.homePageConfiguration.homePageVersion1; track page) {
            <swiper-slide>
              <div
                class="marketingItemReposition"
                [style.background-image]="getbackgroundImage(page)"
                style="height: 100%"
                (click)="entryClicked(page)"
                >
                <div class="marketing_box">
                  @if (HasForgroundImg(page)) {
                    <div class="foregroundContainer">
                      <div class="foregroundSetup" [style.background-image]="getforegroundImage(page)"></div>
                    </div>
                  }
                  <div class="titleText" #titleTextRef [innerHTML]="htmlContent"></div>
                  <!-- EN -->
                  @if (currentLanguage == 'en') {
                    <div>
                      @if (page.buttonLink && page.desktopButtonTextEN) {
                        <button
                          (click)="openStore(page.buttonLink)"
                          class="styledButton">
                          {{ stripHtml(page.desktopButtonTextEN) }}
                        </button>
                      }

                      <!--
                      @if (!(page.buttonLink && page.desktopButtonTextEN)) {
                        
                        @if(!mobile) {
                          <button
                            style="visibility: hidden;"
                            class="styledButton">
                            {{ stripHtml(page.desktopButtonTextEN) }}
                          </button>
                        }
                        
                      }
                      -->
                    </div>
                  }
                  <!-- FR -->
                  @if (currentLanguage == 'fr') {
                    <div>
                      @if (page.buttonLink && page.desktopButtonTextFR) {
                        <button
                          (click)="openStore(page.buttonLinkFR)"
                          class="styledButton">
                          {{ stripHtml(page.desktopButtonTextFR) }}
                        </button>
                      }

                      <!--
                      @if (!(page.buttonLink && page.desktopButtonTextFR)) {

                        <button
                          style="visibility: hidden;"
                          class="styledButton">
                          {{ stripHtml(page.desktopButtonTextFR) }}
                        </button>
                      }
                      -->
                    </div>
                  }
                </div>
              </div>
            </swiper-slide>
          }
        </swiper-container>
      }
    </div>
  </ion-content>
}




<!--special UI-->
@if (homepageOption() == 10) {
  <ion-content [fullscreen]="false" [ngClass]="{'disable-background-color': !this.setting.UIshowBackground}" style="overflow: auto; overscroll-behavior: contain;">
    <ion-toolbar class="disable-background-color repositioning_v10" >
      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>
      <ion-title >
        <div class="titleBar_type2">
          <!--
          @if (NotificationService.showNotificationBell) {
            <ion-buttons #notificationV1 class="notificationbutton" (click)="NotificationBellService.openNotificationBell(this.AllNotifications, 1)" class="bellBtnPosition">
              <div class="bellimgContainer">
                <fa-icon [icon]="bellIcon" id="bellsize"></fa-icon>
                @if (this.valideNotification > 0) {
                  <div class="notificationCircle">
                    <p>{{this.valideNotification}}</p>
                  </div>
                }
              </div>
            </ion-buttons>
          }
          -->
        </div>
      </ion-title>
    </ion-toolbar>

    <div class="container">
      @if(setting.configuration?.welcomeOptions?.addWelcomeMessage && this.auth.isAuthenticated) {
        <div class="welcomeBarV10">
          <div class="welcomeMessage">
            {{ 'Welcome.Hi' | translate }} {{ this.auth?.firstName }}
          </div>
          <div class="notificationBell_Welcome">
            @if (NotificationService.showNotificationBell) {
              <ion-buttons #notificationV1 class="notificationbutton" (click)="NotificationBellService.openNotificationBell(this.AllNotifications, 1)" class="bellBtnPosition">
                <div class="bellimgContainer">
                  <!--<fa-icon icon="bell" id="bellsize"></fa-icon>-->
                  <fa-icon [icon]="bellIcon" id="bellsize"></fa-icon>
                  @if (this.valideNotification > 0) {
                    <div class="notificationCircle">
                      <p> {{ this.valideNotification }} </p>
                    </div>
                  }
                </div>
              </ion-buttons>
            }
          </div>
        </div>
      }
      <div class="V10container">
        <!--
        @if(setting.configuration?.welcomeOptions?.addWelcomeMessage && this.auth.isAuthenticated) {
          <div class="welcomeBarV10">
            <div class="welcomeMessage">
              {{ 'Welcome.Hi' | translate }} {{ this.auth?.firstName }}
            </div>
            <div class="notificationBell_Welcome">
              @if (NotificationService.showNotificationBell) {
                <ion-buttons #notificationV1 class="notificationbutton" (click)="NotificationBellService.openNotificationBell(this.AllNotifications, 1)" class="bellBtnPosition">
                  <div class="bellimgContainer">
                    <fa-icon [icon]="bellIcon" id="bellsize"></fa-icon>
                    @if (this.valideNotification > 0) {
                      <div class="notificationCircle">
                        <p> {{ this.valideNotification }} </p>
                      </div>
                    }
                  </div>
                </ion-buttons>
              }
            </div>
          </div>
        }
        -->
        
        <!--splitting this in different section-->
        @if (setting.configuration.homePageConfiguration.homePageVersion1.length > 0) {
          <swiper-container
            #swiper
            loop="true"
            navigation="false"
            pagination='{"clickable": true}'
            (slidechange)="onSlideChanged()"
            style="height: 100%;"
            >
            @for (page of setting.configuration.homePageConfiguration.homePageVersion1; track page) {
              <swiper-slide>
                <div
                  class="marketingItemReposition"
                  [style.background-image]="getbackgroundImage(page)"
                  style="height: 100%;"
                  (click)="entryClicked(page)"
                  >
                  <div class="marketing_boxV10">
                    @if (HasForgroundImg(page)) {
                      <div class="foregroundContainer">
                        <div class="foregroundSetup" [style.background-image]="getforegroundImage(page)"></div>
                      </div>
                    }
                    <!--<div class="titleText" #titleTextRef [innerHTML]="htmlContent"></div>-->
                    <!-- EN -->
                    @if (currentLanguage == 'en') {
                      <div>
                        @if (page.buttonLink && page.desktopButtonTextEN) {
                          <button
                            (click)="openStore(page.buttonLink)"
                            class="styledButtonV10">
                            {{ stripHtml(page.desktopButtonTextEN) }}
                          </button>
                        }
                        @if (!(page.buttonLink && page.desktopButtonTextEN)) {
                          <button
                            style="visibility: hidden;"
                            class="styledButtonV10">
                            {{ stripHtml(page.desktopButtonTextEN) }}
                          </button>
                        }
                      </div>
                    }
                    <!-- FR -->
                    @if (currentLanguage == 'fr') {
                      <div>
                        @if (page.buttonLink && page.desktopButtonTextFR) {
                          <button
                            (click)="openStore(page.buttonLinkFR)"
                            class="styledButtonV10">
                            {{ stripHtml(page.desktopButtonTextFR) }}
                          </button>
                        }
                        @if (!(page.buttonLink && page.desktopButtonTextFR)) {
                          <button
                            style="visibility: hidden;"
                            class="styledButtonV10">
                            {{ stripHtml(page.desktopButtonTextFR) }}
                          </button>
                        }
                      </div>
                    }
                  </div>
                </div>
              </swiper-slide>
            }
          </swiper-container>
        }
      </div>

      <div class="V10container-content">
        <!--Game section-->
        <div class="gameTriggerContainer">
            <div class="gameStartSection">
              <div class="sectionTitle">
                <span class="font-change" [innerHTML]="'Home.GameTitle' | translate"></span>
              </div>
              <div class="gameBtnContainger">
                <button class="gameBtnStyle" [disabled]="!this.gamesService.games" (click)="startGame()">{{ 'Home.Play' | translate}}</button>
              </div>
            </div>
            <div class="gameDescription">
              <p>{{ 'Home.GameDesc' | translate}}</p>
            </div>
        </div>

        <!--news/blogs-->
        <div class="newsBlogsContainer">
          <div class="newsBlogsTitle">
            <p class="Section-Title PaytoneFont removeMargin" style="color: #018DD1;">
              {{ 'Home.WhatsNew' | translate}} 
            </p>
          </div>
          <div class="newsBlogsList">
            <!--add margin-left of 20px for the first value -->

            <!--merged news and blogs then reorganized them.-->
            @for(newsblog of newsAndBlogs; track newsblog) {
              @if(newsblog.isNews) {
                <div class="newsblog" (click)="openMessages()" [ngStyle]="{ 'margin-left': $first ? '20px' : null,'margin-right': $last ? '20px' : null }">
                  <div class="newsblog_Image">
                    @if (newsblog.images.imgMobileURL) {
                      <img class="imgs" [src]="getnewsImage(newsblog)">
                    }
                  </div>
                  <div class="newsblog_Title">
                    <p class="removeMargin blogTitle" style="font-size: 20px;">
                      {{ newsblog.title.translations[translationService.getLanguage()] }}
                    </p>
                  </div>
                  <div class="removeMargin newsblog_Text">
                    <div class="blogText" style="font-size: 12px; margin: 0; line-height: 1;" [innerHTML]="newsblog.shortDescription.translations[translationService.getLanguage()]">
                      <!--{{ newsblog.shortDescription.translations[translationService.getLanguage()] }}-->
                    </div>
                  </div>
                </div>
              } @else if (newsblog.isBlogs) {
                <div class="newsblog" (click)="openMessages()" [ngStyle]="{ 'margin-left': $first ? '20px' : null,'margin-right': $last ? '20px' : null }">
                  <div class="newsblog_Image">
                    @if (newsblog.images.imgMobileURL) {
                      <img class="imgs" [src]="getblogsImage(newsblog)">
                    }
                  </div>
                  <div class="newsblog_Title">
                    <p class="removeMargin blogTitle" style="font-size: 20px;">
                      {{ newsblog.title.translations[translationService.getLanguage()] }}
                    </p>
                  </div>
                  <div class="removeMargin newsblog_Text">
                    <div class="blogText" style="font-size: 12px; margin: 0; line-height: 1;" [innerHTML]="newsblog.shortDescription.translations[translationService.getLanguage()]">
                      <!--{{ newsblog.shortDescription.translations[translationService.getLanguage()] }}-->
                      
                    </div>
                  </div>
                </div>
              }
              
            }

            <!--
            @for(newsblog of news; track newsblog) {
              <div class="newsblog" (click)="openMessages()" [ngStyle]="{ 'margin-left': $first ? '20px' : null,'margin-right': $last ? '20px' : null }">
                <div class="newsblog_Image">
                  @if (newsblog.images.imgMobileURL) {
                    <img class="imgs" [src]="getnewsImage(newsblog)">
                  }
                </div>
                <div class="newsblog_Title">
                  <p class="removeMargin font-change blogText" style="font-size: 14px; font-weight: bold;">
                    {{ newsblog.title.translations[translationService.getLanguage()] }}
                  </p>
                </div>
                <div class="removeMargin newsblog_Text">
                  <p class="blogText" style="font-size: 11px;">
                    {{ newsblog.shortDescription.translations[translationService.getLanguage()] }}
                  </p>
                </div>
              </div>
            }

            @for(newsblog of blogs; track newsblog) {
              <div class="newsblog" (click)="openMessages()" [ngStyle]="{ 'margin-left': $first ? '20px' : null,'margin-right': $last ? '20px' : null }">
                <div class="newsblog_Image">
                  @if (newsblog.images.imgMobileURL) {
                    <img class="imgs" [src]="getblogsImage(newsblog)">
                  }
                </div>
                <div class="newsblog_Title">
                  <p class="removeMargin font-change blogText" style="font-size: 14px; font-weight: bold;">
                    {{ newsblog.title.translations[translationService.getLanguage()] }}
                  </p>
                </div>
                <div class="removeMargin newsblog_Text">
                  <p class="blogText" style="font-size: 11px;">
                    {{ newsblog.shortDescription.translations[translationService.getLanguage()] }}
                  </p>
                </div>
              </div>
            }
            -->
            

            <!--
            <div class="newsblog">

            </div>

            <div class="newsblog" style="margin-right: 20px;">

            </div>
            -->
          </div>
        </div>

        <!--(either login option, or it goes for the recent orders)-->
        @if (this.auth.isAuthenticated) {
          <div class="recentOrderContainer">
            <div class="recentOrdersTitle">
              <p class="PaytoneFont Section-Title removeMargin" style="color: #EE5298;">{{ 'Home.RecentOrder' | translate}}</p>
            </div>
            <div class="recentOrders">

              <!-- do a loop for each recent order. -->
              <!--@for (order of orders; track order) {-->
              @for (order of orders.slice(0, 5); track order) {
                <ion-card style="border-radius: 15px;">
                  <!-- [routerLink]="['/order/tracking', order.orderId]" -->
                  <a routerDirection="root" style="text-decoration: none;">
                    <ion-item>
                      <ion-icon [name]="(order.isShipping) ? 'cube' : (order.isDelivery) ? 'car' : 'basket'" slot="start" style="margin-inline-end: 10px;"></ion-icon>
                      <ion-label id="order-info" style="font-size: 12px;">#{{order.orderNumber}} {{order.storeName}}</ion-label>
                      @if (order.storeAllowSales) {
                        <button (click)="reOrder(order)" class="reorder">{{'General.ReOrder' | translate}}</button>
                      }
                      <button (click)="detail(order.orderId, order.isShipping)" class="details">{{'General.Details' | translate}}</button>
                    </ion-item>
                  </a>
                </ion-card>
              }

            </div>
          </div>
        }
        
        @if (!this.auth.isAuthenticated) {
          <!--If not auth, just add the logins here (maybe use the looks of the checkout here)-->
          <div class="loginAndRegister">
            <div class="recentOrdersTitle">
              <!--<p class="PaytoneFont Section-Title removeMargin" style="font-size: 20px;">{{ 'Home.LoginRegisterTitle' | translate}}</p>-->
              <p class="PaytoneFont Section-Title removeMargin" style="color: #EE5298;">{{ 'Home.RecentOrder' | translate}}</p>
            </div>
            <div class="loginTxtAndLink">
              <p class="PoppinsFont removeMargin" style="margin-left: 20px;">{{ 'Home.LoginRecentOrder' | translate}}</p>

              <div class="loginBtnContainer">
                <button class="loginBtn" (click)="goToLogin()">{{ 'Home.LoginRegister' | translate}}</button>
              </div>
            </div>
            


            <!--<app-authentication-page></app-authentication-page>-->
          </div>
        }
        
      </div>
      


    </div>
  </ion-content>
}
  